import AbstractRule from './AbstractRule';
import {AnySchema} from 'yup';

export default class RequiredRule extends AbstractRule {
	protected name = 'required';

	mutateScheme<S extends AnySchema>(scheme: S): S {
		return scheme.required('Validator.is_required');
	}
}
